import React from 'react';
import CartElementItinerary from "./CartElementItinerary";
import { Plural, Trans, useLingui } from '@lingui/react/macro';
import { isTacActivity, TAC_TEMPLATE_TYPES } from '../../constants/tacConstants';
import { dateStringToUrlString } from '../../utils/dateTimeUtils';

function CartElementTacItinerary(props) {
    const entry = props.entry;
    const nrGuests = entry.nrAdults + entry.nrChildren;
    const isActivity = isTacActivity(entry.serviceProfileTemplateType);
    const {t} = useLingui();

    return (
        <CartElementItinerary
            name={entry.name}
            imageReference={entry.serviceProfileId}
            remove={() => props.removeTacFromCart(entry.id)}
            linkTo={{
                pathname: `/tac/restaurants/${dateStringToUrlString(props.date)}${isActivity ? `/${TAC_TEMPLATE_TYPES.ACTIVITY}` : ''}`
            }}
            price={entry.price}
            changePassengersLinkText={t({id: "edit_reservation"})}
            changePassengersLinkTo={{
                pathname: `/tac/restaurants/${dateStringToUrlString(props.date)}${isActivity ? `/${TAC_TEMPLATE_TYPES.ACTIVITY}` : ''}`,
                state: { preselectedDetails: { ...entry } }
            }}
            status={entry.status}
        >
            <div className="my-2">
                {isActivity
                    ? <Trans id="x_guests_at_time">
                        <div className="mb-1">
                            <Plural value={nrGuests} one="# guest" other="# guests" />
                        </div>
                        <div>
                            at <span className="font-bold">{entry.time}</span>
                        </div>
                    </Trans>
                    : <Trans id="table_for_x_people">
                        <div className="mb-1">
                            Table for <Plural value={nrGuests} one="# person" other="# people" />
                        </div>
                        <div>
                            at <span className="font-bold">{entry.time}</span>
                        </div>
                    </Trans>
                }
            </div>
        </CartElementItinerary>
    )
}

export default CartElementTacItinerary;